import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY_STORAGE = "panda_admin_key";

export const setAdminKey = (key) => localStorage.setItem(ADMIN_KEY_STORAGE, key);
export const getAdminKey = () => localStorage.getItem(ADMIN_KEY_STORAGE) || "";
export const clearAdminKey = () => localStorage.removeItem(ADMIN_KEY_STORAGE);

const adminHeaders = () => ({ "x-admin-key": getAdminKey() });

export const verifyAdmin = (key) =>
  axios.post(`${API}/admin/verify`, { key }).then((r) => r.data);

// Stories
export const getStories = () => axios.get(`${API}/stories`).then((r) => r.data);
export const createStory = (data) =>
  axios.post(`${API}/stories`, data, { headers: adminHeaders() }).then((r) => r.data);
export const updateStory = (id, data) =>
  axios.put(`${API}/stories/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteStory = (id) =>
  axios.delete(`${API}/stories/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// Gallery
export const getGallery = () => axios.get(`${API}/gallery`).then((r) => r.data);
export const addGalleryImage = (data) =>
  axios.post(`${API}/gallery`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteGalleryImage = (id) =>
  axios.delete(`${API}/gallery/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// RSVP
export const submitRsvp = (data) =>
  axios.post(`${API}/rsvp`, data).then((r) => r.data);
export const listRsvps = () =>
  axios.get(`${API}/rsvp`, { headers: adminHeaders() }).then((r) => r.data);

// Messages
export const getMessages = () =>
  axios.get(`${API}/messages`).then((r) => r.data);
export const postMessage = (data) =>
  axios.post(`${API}/messages`, data).then((r) => r.data);
